module.exports = __webpack_public_path__ + "assets/icon_data_highlight.2c4fbb4a.svg";